import {booleanAttribute, Component, HostBinding, Input} from '@angular/core';

/**
 * The dashboard's designed empty / pending state (OCA-E-159 .adb-empty, ITP-E-147-04): a dashed box with an icon, an
 * optional title and body, and projected content (a link or a button) under them. Each card keeps its own copy and
 * passes it in; `compact` is for small slots (96 px tall instead of 160 px).
 */
@Component({
  standalone: false,
  selector: 'app-admin-dashboard-empty',
  templateUrl: './admin-dashboard-empty.component.html',
  styleUrls: ['./admin-dashboard-empty.component.scss']
})
export class AdminDashboardEmptyComponent {
  /** Font Awesome classes of the icon. */
  @Input() icon = 'fa-regular fa-chart-simple';
  @Input() title: string;
  @Input() body: string;
  @Input({transform: booleanAttribute}) compact = false;

  /** A static `title="…"` would otherwise also stay on the host and become a hover tooltip over the whole box. */
  @HostBinding('attr.title') readonly hostTitle: string = null;
}
